import { $t } from '../../composables/i18n'
import { Codebook } from '../Codebook'

export enum ImplementationTaskTypeId {
  WEB = 'web',
  CHM = 'chm',
  API_LOCKS = 'api_locks',
  PAY = 'pay',
  CUSTOM = 'custom',
}

export class ImplementationTaskType extends Codebook<ImplementationTaskTypeId> {
  static readonly WEB = new ImplementationTaskType(
    ImplementationTaskTypeId.WEB,
    () => $t('Website'),
    'globe',
  )

  static readonly CHM = new ImplementationTaskType(
    ImplementationTaskTypeId.CHM,
    () => $t('Channel manager'),
    'arrows-rotate',
  )

  static readonly API_LOCKS = new ImplementationTaskType(
    ImplementationTaskTypeId.API_LOCKS,
    () => $t('API / Locks'),
    'plug',
  )

  static readonly PAY = new ImplementationTaskType(
    ImplementationTaskTypeId.PAY,
    () => $t('Payments'),
    'credit-card',
  )

  static readonly CUSTOM = new ImplementationTaskType(
    ImplementationTaskTypeId.CUSTOM,
    () => $t('Custom task'),
    'list-check',
  )

  private constructor(
    id: ImplementationTaskTypeId,
    public readonly name: () => string,
    public readonly icon: string,
  ) {
    super(id)
  }
}
